import { render, staticRenderFns } from "./quick-order.vue?vue&type=template&id=27a7349a&scoped=true&"
import script from "./quick-order.vue?vue&type=script&lang=js&"
export * from "./quick-order.vue?vue&type=script&lang=js&"
import style0 from "./quick-order.vue?vue&type=style&index=0&id=27a7349a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a7349a",
  null
  
)

export default component.exports